<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="ded">
<p class="ct"><a class="xref" href="#/OEBPS/pppsorrowend0006#toc">Dedication</a></p>
<p class="ded">To Katherine V. Forrest, Judy Greber (Gillian Roberts), Michael Nava, Katherine Neville, and Sarah Smith.<br class="calibre1"/><br class="calibre1"/>Thank you for all you taught me in class and<br class="calibre1"/>continue to teach me through your books.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ppp-sorrowend0005.vue?5cfb5237